import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Icon, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import DeleteModal from './modal/deleteModal';

const parseTasks = (tasks) => {
  return tasks.map((item, index) => ({
    'text': `${item.serviceCode3} | ${item.description}`,
    'value': index,
  }));
};

class Fields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'isOpen': false,
      'selectedIndex': '',
      'selectedTask': '',
    };
    this.handleTaskChange = this.handleTaskChange.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  handleModalClose() {
    this.setState({
      'isOpen': false,
      'selectedIndex': '',
      'selectedTask': '',
    });
  }

  handleTaskChange(event, data) {
    this.props.selectComboTask(data.value);
  }

  handleSaveClick(index) {
    const {selectedCombo, selectedTask} = this.props;
    this.props.assignComboTask(index, selectedCombo.code, selectedTask);
  }

  handleDeleteClick(index, selectedTask) {
    this.setState({
      'isOpen': true,
      'selectedIndex': index,
      'selectedTask': selectedTask,
    });
  }

  handleRemoveClick(index) {
    this.props.removeComboTask(index);
  }

  renderTableRows(fields = []) {
    return fields.map((item, index) => this.renderRow(index, item));
  }

  renderRow(index, task = {}) {
    return (
      <Table.Row key={index}>
        <Table.Cell>{this.renderTask(task)}</Table.Cell>
        {this.renderActions(index, task)}
      </Table.Row>
    );
  }

  renderTask(task = {}) {
    const {candidateTasks} = this.props;

    if (!task.description) {
      return (
        <Dropdown selection search fluid
          name='task'
          options={parseTasks(candidateTasks)}
          onChange={this.handleTaskChange}
        />
      );
    }

    return task.description;
  }

  renderActions(index, task) {
    if (!task.description) {
      return (
        <Table.Cell collapsing textAlign='center'>
          <Icon link size='big' name='save' onClick={this.handleSaveClick.bind(this, index)} />
          <Icon link size='big' name='close' color='red' onClick={this.handleRemoveClick.bind(this, index)} />
        </Table.Cell>
      );
    }

    return (
      <Table.Cell collapsing textAlign='center'>
        <Icon link size='big' name='delete' onClick={this.handleDeleteClick.bind(this, index, task)} />
      </Table.Cell>
    );
  }

  render() {
    const {tasks} = this.props;
    const {isOpen, selectedTask, selectedIndex} = this.state;

    return (
      <DeleteModal
        trigger={
          <Table.Body>
            {this.renderTableRows(tasks)}
          </Table.Body>
        }
        isOpen={isOpen}
        task={selectedTask}
        index={selectedIndex}
        closeModal={this.handleModalClose}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'selectedCombo': state.comboTasks.selectedCombo,
    'selectedTask': state.comboTasks.selectedTask,
    'candidateTasks': state.comboTasks.candidateTasks,
  };
};

const {
  removeComboTask,
  deleteComboTask,
  assignComboTask,
  selectComboTask,
} = Actions;

export default connect(mapStateToProps, {
  removeComboTask,
  deleteComboTask,
  assignComboTask,
  selectComboTask,
})(Fields);
